import * as React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";

interface ActionItemEditFormProps {
  editedPrompt: string;
  setEditedPrompt: (value: string) => void;
  handleCancelEditing: () => void;
  handleToggleEditing: () => void;
  isPending: boolean;
}

export const ActionItemEditForm: React.FC<ActionItemEditFormProps> = ({
  editedPrompt,
  setEditedPrompt,
  handleCancelEditing,
  handleToggleEditing,
  isPending,
}) => (
  <>
    <Textarea
      value={editedPrompt}
      onChange={(e) => setEditedPrompt(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      className="bg-neutral-white text-neutral-400"
      rows={5}
    />
    <div className="flex justify-end gap-2 mt-2">
      <Button
        size="sm"
        variant="outline"
        onClick={(e) => {
          e.stopPropagation();
          handleCancelEditing();
        }}
        className="text-neutral-400"
      >
        Cancel
      </Button>
      <Button
        size="sm"
        variant="default"
        onClick={(e) => {
          e.stopPropagation();
          handleToggleEditing();
        }}
        disabled={isPending}
      >
        {isPending ? <Loader2 className="size-4 animate-spin" /> : "Save"}
      </Button>
    </div>
  </>
);
